import React from 'react';
import { Helmet } from 'react-helmet';

interface TitleProps {
  title: string;
  suffix?: boolean;
}

const Title: React.FC<TitleProps> = ({ title, suffix = true }) => {
  const fullTitle = suffix ? `${title} | Quick Flick` : title;
  
  return (
    <Helmet>
      <title>{fullTitle}</title>
    </Helmet>
  );
};

export default Title; 